export class SignatureImageFile {
    constructor (public signatureImageFileBase64: string, public width: number, public height: number) {
    }
}